// extracted by mini-css-extract-plugin
export var center = "_4l-2";
export var clickableRow = "_4l-5";
export var expandedRow = "_4l-7";
export var hoverable = "_4l-4";
export var left = "_4l-1";
export var right = "_4l-3";
export var row = "_4l-0";
export var selectedRow = "_4l-6";
export var summaryRow = "_4l-8";